import { AfterContentInit, Component, forwardRef, Injector, input, } from '@angular/core';

import { MatInputModule } from '@angular/material/input';
import { AbstractControl, ControlValueAccessor, FormControl,NG_VALIDATORS,NG_VALUE_ACCESSOR, NgControl, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { provideNgxMask } from 'ngx-mask';
import { BaseControlValueAccessor } from '../base-control-value-accessor';

@Component({
  selector: 'lib-form-text-area',
  imports: [MatInputModule, ReactiveFormsModule],
  templateUrl: './form-text-area.component.html',
  styleUrl: './form-text-area.component.scss',
  providers: [
    provideNgxMask(),
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormTextAreaComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FormTextAreaComponent),
      multi: true
    },

  ],
})

export class FormTextAreaComponent  extends BaseControlValueAccessor<string> implements AfterContentInit,  ControlValueAccessor, Validator {
  label = input<string | null>(null)
  rows = input<number>(3);
  placeholder = input<string | null>(null);
  required = input<boolean>(false);
  control!: FormControl;


  constructor(private injector: Injector) {
    super()
  }

  public get invalid(): boolean | null {
    return this.control ? this.control?.invalid : false;
  }


  public get showError(): boolean | null {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }


  validate(control: AbstractControl): ValidationErrors | null {
    return control.valid ? null : control.errors;
  }

  ngAfterContentInit(): void {
      const ngControl: NgControl = this.injector.get(NgControl, null) as NgControl;
      if (ngControl) {
        this.control = ngControl.control as FormControl;
      } else {
        this.control = new FormControl();
      }
  
    }
}
